import { jsx as t } from "react/jsx-runtime";
const o = () => /* @__PURE__ */ t(
  "svg",
  {
    width: "10",
    height: "3",
    viewBox: "0 0 10 3",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "partial-icon",
    children: /* @__PURE__ */ t("path", { d: "M1 1.5H9", stroke: "white", strokeWidth: "1.5", strokeLinecap: "round" })
  }
);
export {
  o as PartialIcon
};
//# sourceMappingURL=index.es562.js.map
